module.exports = __webpack_public_path__ + "img/img-buy-online-3.516f0f3a.svg";